import { gapi } from "gapi-script";
import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";
import { showApiErrorMessages } from "../../../helpers";
export function syncCalendar(
  token: string,
  canceled: boolean,
  actorType: string,
  id: number | string
): Promise<ApiResponse> {
  return Axios.post(
    "v1/google_calendar_sync/sync",
    {
      token,
      canceled,
    },
    { headers: { ActorType: actorType, ActorId: id } }
  ).then((response: ApiResponse) => {
    if (response.isSuccess) {
      window.location.reload();
    } else {
      showApiErrorMessages(response);
    }
  });
}

const Scopes =
  "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/calendar";
export const getClientAccessToken = (
  canceled: boolean,
  actorType: string,
  id: string | number
) => {
  gapi.auth2.authorize(
    { client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID, scope: Scopes },
    (res: any) => {
      if (res) {
        if (res?.access_token)
          return syncCalendar(res.access_token, canceled, actorType, id);
      }
    }
  );
};
